"use strict";

/*
* ***********************************Example of Usage***********************************
*
* 1 - Simple usage
*    <TruncateText text="Big text to show you that truncate works" />
*
* 2 - With maxWidth
*    <TruncateText text="A example text" maxWidth="50" />
*
* 3 - With className
*    <TruncateText text="A example text" className="fs-14" />
*
* 4 - Never render Tooltip
*    <TruncateText text="A example text" showTooltip=false />
*
*/

import Tooltip from "app/shared/components/Tooltip/tooltip";
import cx from "classnames";

class TruncateTextWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTooltipNeeded: true
    };

    this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this);
  }
  getHiddenTextWidth() {
    if (this.refs.hiddenText) {
      return this.refs.hiddenText.offsetWidth;
    }
  }
  handleOnMouseEnter() {
    const hiddenTextWidth = this.getHiddenTextWidth();
    if(hiddenTextWidth) {
      this.setState({
        isTooltipNeeded: hiddenTextWidth > this.props.maxWidth
      });
    }
  }
  render() {
    const shouldApplyTooltip = this.state.isTooltipNeeded && this.props.showTooltip;

    return (
      <div>
        {
          shouldApplyTooltip
          ? <Tooltip title={this.props.text}>
              <TruncateText {...this.props} onMouseEnter={this.handleOnMouseEnter}/>
            </Tooltip>
          : <TruncateText {...this.props} onMouseEnter={this.handleOnMouseEnter}/>
        }
        <span ref="hiddenText" className="d-b p-a v-h">{this.props.text}</span>
      </div>
    );
  }
}

TruncateTextWrapper.defaultProps = {
  maxWidth: "100",
  showTooltip: true
};

TruncateTextWrapper.propTypes = {
  text: React.PropTypes.string.isRequired,
  maxWidth: React.PropTypes.string,
  className: React.PropTypes.string,
  showTooltip: React.PropTypes.bool
};

function TruncateText(props) {
  let classNames = cx("truncate-sentence d-ib", props.className);

  return (
    <div className={classNames} style={{maxWidth: props.maxWidth}} onMouseEnter={props.onMouseEnter}>
      {props.text}
    </div>
  );
}

module.exports = TruncateTextWrapper;



// WEBPACK FOOTER //
// ./app/shared/components/Truncate/truncate-text.jsx